import classname from 'classnames';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

const Modal = ({ children, visible, addClass, variant = 'small' }) => {

    const modalWrapperClass = classname({
        'modal_wrapper--small': variant === 'small',
        'modal_wrapper--medium': variant === 'medium',
        'modal_wrapper--large': variant === 'large'
    });

    const modalClass = classname(
        addClass,
        {
            modal: true
        }
    );

    return visible ?
        ReactDOM.createPortal(
            <div className={modalClass}>
                <div className={`modal__content ${modalWrapperClass}`}>
                    {children}
                </div>
            </div>
            , document.body
        )
        : null;
}

Modal.propTypes = {
    visible: PropTypes.bool,
    addClass: PropTypes.string,
    children: PropTypes.node,
    variant: PropTypes.string
}

export default Modal;
